import { inject } from '@angular/core';
import { Router, type CanActivateFn, type CanMatchFn } from '@angular/router';

import { AuthService } from '@echospaces-web-monorepo/es-auth';

import { SUPER_ADMIN_ROLE } from './is-super-admin';

/**
 * Route guard — denies access unless the caller is `super-admin`. Used
 * both as a `canActivate` (after the authGuard has run) and as a
 * `canMatch` so the lazy bundle for /admin/* never even loads for
 * non-super-admins. Redirects to `/dashboard` rather than 403'ing — the
 * goal is "section invisible", not "permission error visible".
 */
export const superAdminGuard: CanActivateFn & CanMatchFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  const hasRole = auth.user()?.roles.includes(SUPER_ADMIN_ROLE) ?? false;
  if (hasRole) return true;

  router.navigate(['/dashboard']);
  return false;
};
